/**
 * Calculate VAT on a net amount using native JS rounding.
 * @param {number} net    Net amount (e.g. line-item sum or total)
 * @param {number} rate   VAT rate (default 0.21 for 21%)
 * @returns {number}      VAT amount, rounded to two decimals
 */
export function calculateVat(net, rate = 0.21) {
  // Multiply, then round to 2 decimals:
  // toFixed(2) returns a string; Number(...) converts back to a numeric type
  return Number((net * rate).toFixed(2))
}
